export default "/fonts/fa-brands-400.ttf?450a5c898f0b184b968b971eaf7c5fa4";